import * as React from "react";
import '../App.css';
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { countries, countryOptions } from "../utils/constants/countryOptions";
import { queryTypesByCountry } from "../utils/constants/constants";
import { useAuth } from "../context/AuthContext";
import WritePrefs from "./datawriter/writePrefs";
import { useEffect } from "react";

function QueryFiltersPage() {

    const navigate = useNavigate();
    const [selectedCountry, setSelectedCountry] = React.useState("US");
    const [selectedJurisdictionIndex, setSelectedJurisdictionIndex] = React.useState(0);
    const [queryType, setQueryType] = React.useState("Driver Status");
    const [save, setSave] = React.useState(); 
    //const [ formData, setFormData ] = React.useState(prefs)
    const { email, token } = useAuth();
    const saver = React.useRef();

    // Determine role from session (matches constants.js)
    const roles = JSON.parse(sessionStorage.getItem("roles")) || [];
    //const email = sessionStorage.getItem("email");
    const role = roles?.includes("Admin") || roles?.includes("minimalDrivReq") ? "minimal" : "cdlisUsr";
    
    const usrRoles = JSON.parse(sessionStorage.getItem("roles")) ?? [];
    const ctx = {
    role:
        usrRoles.includes("cdlisAdmin") ? "admin" :
        usrRoles.includes("minimalDrivReq") ? "minimal" :
        "cdlisUsr",
    caFcwdOnly: usrRoles.includes("searchCnFcwd"),
    };
    const config = queryTypesByCountry[selectedCountry] ?? queryTypesByCountry.OTHER;
    const queryTypes = typeof config === "function" ? config(ctx) : config;
    useEffect(() => {
    if (!queryTypes.includes(queryType)) {
        setQueryType(queryTypes[0] || "");
    }
    }, [selectedCountry, role]);
    const onSubmit = (event) => {
        event.preventDefault();

        const prefs ={
            "country": selectedCountry,
            "state": selectedJurisdictionIndex,
            "query": queryType
        }

        setSave("saved return to query")
        
        try {    
            ReactDOM.render(<WritePrefs email={email} prefs={prefs} token={token} />,
                saver.current);
            } catch(err){
                alert(err)
        }
    }
 
    const cancelSubmit = (event) => {
        
        event.preventDefault();
        navigate('/');
    }
    return(
        <div className='Index'>
                <div id='table' style={{width: '50%'}}>
                    <div id="banner-search">
                        <h4>Manage Query Default</h4>
                        <div>{save}</div>
                    </div>
                    <form id="Index-form" onSubmit={onSubmit}>
                    <label>
                        <b>Country:</b>
                        <br />
                         <select
                            className="form-control form-select-lg mb-3"
                            value={selectedCountry}
                            onChange={(e) => {
                            setSelectedCountry(e.target.value);
                            setSelectedJurisdictionIndex(0);
                            }}
                        >
                            {countries.map((country) => (
                            <option key={country.code} value={country.code}>
                                {country.label}
                            </option>
                            ))}
                        </select>
                    </label>
                    <br />
                    <label>
                    <b>Query Type:</b>
                    <br />
                    <select
                        className="form-select form-select-lg mb-3"
                        name="selectedType"
                        value={queryType}
                        onChange={(e) => setQueryType(e.target.value)}
                    >
                        {queryTypes.map((type) => (
                        <option key={type} value={type}>
                            {type}
                        </option>
                        ))}
                    </select>
                    </label>
        
                    <br />
                    <label>
                    <b>Jurisdiction:</b>
                    <br />
                    <select
                        className="form-select form-select-lg mb-3"
                        name="selectedJurisdiction"
                        value={selectedJurisdictionIndex}
                        onChange={(e) => setSelectedJurisdictionIndex(parseInt(e.target.value))}
                    >
                        {(countryOptions[selectedCountry] || []).map((j, idx) => (
                        <option key={j.code} value={idx}>
                            {j.label}
                        </option>
                        ))}
                    </select>
                    </label>
                    <br />
                <button type="submit" className="btn btn-primary" id="button">Save</button>
                <button type="button" className="btn btn-primary" id="button" onClick={cancelSubmit}>Cancel</button>
                </form>
                <div ref={saver}></div>
                </div>
            
        </div>
        
    )
}

export default QueryFiltersPage;